import comp from "./FeedListItem";
export default comp;
